import { ComponentProps, forwardRef } from 'react'

import { Autocomplete, styled } from '@mui/material'

import { TextField } from '../TextField/TextField'

export type DropdownOption = {
  label: string
  value: string | number

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any
}

export type SelectDropdownProps = Omit<ComponentProps<typeof Autocomplete<DropdownOption, false, true | false, false>>, 'variant' | 'round' | 'multiple' | 'renderInput'> & {
  round?: boolean
  label?: string
  placeholder?: string
  required?: boolean
  error?: boolean
  name?: string
  options: DropdownOption[]
  helperText?: string
}

export const SelectDropdown = forwardRef<HTMLInputElement, SelectDropdownProps>(({ round, label, placeholder, required, error, helperText, name, ...props }, ref) => {
  return (
    <StyledSelectDropdown
      $round={round}
      disablePortal
      getOptionLabel={(option) => {
        return option.label
      }}
      isOptionEqualToValue={(option, selectedOption) => {
        return option.value === selectedOption.value
      }}
      renderInput={({ inputProps, ...params }) => (
        <TextField
          label={label}
          name={name}
          placeholder={placeholder}
          required={required}
          inputRef={ref}
          inputProps={{
            ...inputProps,
            autoComplete: 'none',
          }}
          error={error}
          helperText={helperText}
          {...params}
        />
      )}
      {...props}
    />
  )
})

const StyledSelectDropdown = styled(Autocomplete<DropdownOption, false, true | false, false>, {
  shouldForwardProp: (prop) => prop !== '$round',
}) <{ $round: boolean | undefined }>`
  width: 100%;

  .MuiAutocomplete-tag {
    margin: 2px 3px;
  }

  .MuiOutlinedInput-root {
    padding: 0px;
  }
`